/**
 * Isolated Frame Utilities
 * Height messaging between a sandboxed srcdoc iframe and the page that embeds it
 */

/**
 * Message type the frame posts its height with; the page's message listener must check for the same value
 */
export const FRAME_HEIGHT_MESSAGE_TYPE = 'struers:embed-height';

/**
 * Script that runs inside the frame and posts its content height to the parent whenever it changes.
 * Place it before the embedded code, so a failing vendor script cannot stop it
 */
export const FRAME_HEIGHT_REPORTER_SCRIPT = `
(function () {
	var lastHeight = -1;
	function reportHeight() {
		var height = Math.ceil(document.documentElement.getBoundingClientRect().height);
		if (height === lastHeight) return;
		lastHeight = height;
		parent.postMessage({ type: '${FRAME_HEIGHT_MESSAGE_TYPE}', height: height }, '*');
	}
	new ResizeObserver(reportHeight).observe(document.documentElement);
	window.addEventListener('load', reportHeight);
})();
`;
